import review from "../img/review.svg"
import avatar from "../img/avatar.png"
import avatar2 from "../img/avatar2.png"
import avatar3 from "../img/avatar3.png"


export const Review = () =>{
 return(
    <section className="reviews container1 center" >
        <h1>Trusted by Thousands of<br/> Happy Customer</h1>
        <h2>These are the stories of our customers who have joined us with great<br/> pleasure when using this crazy feature.</h2>
        <div className="flex">
        <div className="review-card" >
            <div className="flex review-card-flex">
            <div className="flex">
                <img src={avatar} />
                <div className="review-card-up" >
                    <h3>Viezh Robert</h3>
                    <p>Warsaw, Poland</p>
                </div>
            </div>

            <div className="flex" >   
                <p>4.5</p>
                <img src={review}/>
            </div>
            </div>
            <div  className="review-card-down">
            <p  >“Wow... I am very happy to<br/> use this VPN, it turned out to<br/> be more than my expectations and so far<br/> there have been no problems.</p>
            </div>
          
        </div>
        <div className="review-card" >
            <div className="flex review-card-flex">
            <div className="flex">
                <img src={avatar2} />
                <div className="review-card-up" >
                    <h3>Yessica Christy</h3>
                    <p>Shanxi, China</p>
                </div>
            </div>

            <div className="flex" >   
                <p>4.5</p>
                <img src={review}/>
            </div>
            </div>
            <div  className="review-card-down">
            <p  >“I like it because I like to travel<br/> far and still can connect with high speed.”.</p>
            </div>
          
        </div>
        <div className="review-card" >
            <div className="flex review-card-flex">
            <div className="flex">
                <img src={avatar3} />
                <div className="review-card-up" >
                    <h3>Kim Young Jou</h3>
                    <p>Seoul, South Korea</p>
                </div>
            </div>

            <div className="flex" >   
                <p>5.0</p>
                <img src={review}/>
            </div>
            </div>
            <div  className="review-card-down">
            <p  >“This is very unusual for my business<br/> that currently requires a virtual private<br/> network that has high security.”.</p>
            </div>
          
        </div>
  
        

        </div>

 
        
        
    </section>
 )
}